function toggleLoginModal(state) {
  state.loginModal = !state.loginModal;
}
function closeRedirectModal(state) {
  state.redirectModal = false;
}
function setModalType(state, type) {
  state.modalType = type;
}
function setTopNumber(state, number) {
  state.topWszech = number;
}
function setPolskiTopWszech(state, number) {
  state.polskiTopWszech = number;
}
function setGenericModalText(state, text) {
  state.genericModalText = text;
}
function setSearchQuery(state, text) {
  state.searchQuery = text;
}
function setSearchCategory(state, text) {
  state.searchCategory = text;
}
function setLogInFlag(state, setting) {
  state.loggedIn = setting;
}
function selectNote(state, note) {
  state.selectedNote = note;
}
function toggleSearch(state) {
  state.searchActive = !state.searchActive;
}
function setCurrentListId(state, number) {
  state.currentListId = number;
}
export default {
  toggleLoginModal,
  setModalType,
  setTopNumber,
  setPolskiTopWszech,
  setGenericModalText,
  setSearchCategory,
  setSearchQuery,
  setLogInFlag,
  selectNote,
  toggleSearch,
  setCurrentListId,
  closeRedirectModal,
};
